import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { Table, Tag, Space } from "antd";
import moment from "moment";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function Enquiries(props) {
  const [enquiries, setEnquiries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", user);

  // get enquiries
  const getEnquiries = () => {
    setIsLoading(true);
    apiReq(url.GET_ENQUIRIES, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setEnquiries(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getEnquiries();
  }, []);

  // TODO: columns
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      sorter: (a, b) => a.phone - b.phone,
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Company",
      dataIndex: "company",
      key: "company",
      sorter: (a, b) => a.company.localeCompare(b.company),
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Enquiry for",
      dataIndex: "enquiry",
      key: "enquiry",
      sorter: (a, b) => a.enquiry.localeCompare(b.enquiry),
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Date",
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(record._id)}
        >
          <i className="ri-delete-bin-line"></i>
        </button>
      ),
    },
  ];

  // Todo: handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        apiReq(url.DELETE_ENQUIRIES + id, {}, "delete", {
          Authorization: `Bearer ${user.user?.token}`,
        })
          .then((res) => {
            if (res.success) {
              Swal.fire({
                title: "Deleted!",
                text: res.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
              getEnquiries();
            }
          })
          .catch((err) => {
            console.log("err>>>", err);
          });
      }
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Contact Us form enquiries</h5>
              <hr />
              <div style={{ width: "100%", overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={enquiries}
                  bordered
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Enquiries;
